import { additionalFieldsData } from '../../variables/additional-fields-data';

export const validateIBAN = (value) => {
  const maskedValue = additionalFieldsData.iban.maskFunction(value);
  if (maskedValue === value && maskedValue.includes('*')) {
    // if the value is already masked
    return true;
  }

  return additionalFieldsData.iban.regexp.test(value);
};
